import TIML from '../../../framework/timl.js';
import { ShowPage } from '../crud/shared.js';

class FormDetails {
  static timl = `
    table.details-table
      tbody
        tr
          th ID
          td {{ item.id }}
        tr
          th Account ID
          td {{ item.accountId }}
        tr
          th Name
          td {{ item.name }}
        tr
          th Description
          td {{ item.description }}
        tr
          th Status
          td {{ item.status }}
        tr
          th Public
          td {{ item.isPublic }}
        tr
          th Created At
          td {{ item.createdAt }}
        tr
          th Updated At
          td {{ item.updatedAt }}
        tr
          th Created By
          td {{ item.createdBy }}
        tr
          th Updated By
          td {{ item.updatedBy }}
  `;
}

export class FormsShow extends ShowPage {
  static timl = `
    a#share-button.list-view-add-button.float-right[href="/forms/{{ Routing.params.id }}/edit"] Edit
    <Breadcrumbs title="Forms" href="/forms" nameHref="/forms/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="" suffixStyle="display:none;" suffixSeparatorStyle="display:none;">
    div#form-details.mt-15 Loading...
    br
    br
    b.black API Calls:
    .black show the latest 10 api calls and explain any rates/limits
    br
    br
    b.black Submissions:
    .black show the latest 100 submissions and link to a page that shows all of them or use pagination
    br
    br
  `;

  static mapItemToViewModel(item) {
    return {
      item: {
        id: item.id || '—',
        accountId: item.accountId || '—',
        name: item.name || '—',
        description: item.description || '—',
        status: item.status || '—',
        isPublic: item.isPublic ? 'Yes' : 'No',
        createdAt: Util.formatDate(item.createdAt) || '—',
        updatedAt: Util.formatDate(item.updatedAt) || '—',
        createdBy: item.createdBy || '—',
        updatedBy: item.updatedBy || '—'
      }
    };
  }

  static javascript() {
    super.javascript();

    API.get(API.resourceUrl('forms', Routing.params.id))
      .then(data => {
        const viewModel = this.mapItemToViewModel(data.data);
        document.querySelector('#name').innerText = viewModel.item.name;
        TIML.renderInto(document.querySelector('#form-details'), FormDetails, viewModel);
      });
  }
}
